import { IGetResponseBase } from "@/features/financas/views/Indicadores/services/types";
import { Ref } from "vue";

export enum EShortcutTypeChart {
  "Modalidade" = 1,
  "ModalidadeDetalhada" = 7,
  "ModalidadeTempo" = 2,
  "Empresa" = 3,
  "EmpresaTempo" = 4,
  "ModalidadeEmpresa" = 5,
  "tempo" = 6,
  "Adquirentes" = 8
}

export const ShortcutTypeText = new Map<EShortcutTypeChart, string>([
  [EShortcutTypeChart.Empresa, "Empresa"],
  [EShortcutTypeChart.Modalidade, "Modalidade"],
  [EShortcutTypeChart.ModalidadeDetalhada, "Modalidade Detalhada"],
  [EShortcutTypeChart.ModalidadeEmpresa, "Modalidade/Empresa"],
  [EShortcutTypeChart.tempo, "Tempo"],
  [EShortcutTypeChart.ModalidadeTempo, "Modalidade/Tempo"],
  [EShortcutTypeChart.EmpresaTempo, "Empresa/Tempo"],
  [EShortcutTypeChart.Adquirentes, "Adquirentes"]
]);

export enum EEventsChartShortcuts {
  chartUpdate = "chartUpdateShortcut"
}

export enum EEventDialog {
  closeDialog = "closeDialog",
  forceClose = "forceClose",
  openDialog = "openDialog",
  applyDialog = "applyDialog"
}

export enum EEventUserPreferencesActionsDialog {
  openCreate = "openCreate",
  openEdit = "openEdit",
  openList = "openList"
}

export interface ICurrentChartValueDialog {
  netValue: IGetResponseBase[];
  salesCouting: IGetResponseBase[];
}

export interface IUseDialogIndicadores {
  ArrayNumber: (enumValue: Record<string, number | string>) => number[];
  handleOpenDialog: () => void;
  handleForceClose: () => void;
  dialogVendasVisible: Ref<boolean>;
}
